// Home: staff go to All tickets (every app they can see, CT-001), reporters only to My requests.
// Staff are the Editors and Admins, and see every app (poc CT-008); while no app is registered yet,
// Editors go to Apps, where they can register one.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { loadSession } from '@/lib/session';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context, location }) => {
    const session = await loadSession(context.queryClient, location.href);
    if (!session.isStaff) {
      throw redirect({ to: '/my-requests' });
    }
    if (!session.isPlatformAdmin && session.apps.length === 0) {
      throw redirect({ to: '/apps' });
    }
    throw redirect({ to: '/queue' });
  },
});
